import { httpApi } from '@api/http.api.ts';

export interface ClientDetailsResponse {
    nationalities: ClientNationalityResponse[];
    genders: ClientGenderResponse[];
    ranks: ClientRankResponse[];
    locations: ClientLocationResponse[];
    organisations: ClientOrganisationResponse[];
    managers: PersonResponse[];
    trainingManagers: PersonResponse[];
    assessors: PersonResponse[];
    pathwayDetails: PathwayDetails;
}

export interface ClientNationalityResponse {
    id: number;
    name: string;
    isoAlhpa2: string;
}

export interface ClientGenderResponse {
    id: number;
    type: string;
    text: string;
}

export interface ClientRankResponse {
    id: number;
    name: string;
    shortCode: string;
}
export interface PathwayDetails {
    isCareerRoadmapLocked: boolean;
    isRecomendedLocked: boolean;
    isLibraryLocked: boolean;
}
export interface ClientLocationResponse {
    id: number;
    name: string;
}
interface ClientOrganisationResponse {
    id: number;
    name: string;
    locationType: string;
}
interface PersonResponse {
    id: number;
    firstName: string;
    lastName: string;
}

export const getApiClientDetails = (): Promise<ClientDetailsResponse> =>
    httpApi.get<ClientDetailsResponse>(`details`).then(({ data }) => data);
